import { render, staticRenderFns } from "./OptinConfirmed.vue?vue&type=template&id=6ac5983b"
import script from "./OptinConfirmed.vue?vue&type=script&lang=js"
export * from "./OptinConfirmed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports